import { attribute, clickable, collection, isPresent, text, value } from 'ember-cli-page-object';
import flashMessage from 'core/test-support/pages/components/flash-message';
export default (scope = '[data-test-create-upload]', properties = {}) => ({
  scope,
  boxName: text('.summary dd:eq(0)'),
  boxDescription: text('.summary dd:eq(1)'),
  versionId: text('.summary dd:eq(2)'),
  visibility: text('.summary dd:eq(3)'),
  versionDescription: text('.summary dd:eq(4)'),
  cards: collection('.hds-accordion-item', {
    name: text('.column-1 .title'),
    architecture: text('.column-1 .subtitle'),
    checksumType: text('.definition-list dd:eq(0)'),
    checksum: text('.definition-list dd:eq(1)'),
    url: text('.column-2 .subtitle'),
    toggle: clickable('button'),
    progress: value('progress'),
    uploadStats: text('.column-2 .stats'),
    hasUrl: isPresent('.column-2 .subtitle'),
    hasStats: isPresent('.column-2 .stats'),
    hasError: isPresent('.column-2 .error-message'),
    error: text('.column-2 .error-message'),
    hasRetry: isPresent('[data-test-retry-button]'),
    retry: clickable('[data-test-retry-button]'),
    remove: clickable('[data-test-remove-button]')
  }),
  releaseButton: {
    scope: '.hds-button-set button[type="submit"]',
    isDisabled: attribute('disabled')
  },
  laterButton: {
    scope: '[data-test-form-actions] button.hds-button--color-secondary',
    isDisabled: attribute('disabled')
  },
  flash: {
    ...flashMessage,
    resetScope: true
  },
  ...properties
});